import { render, staticRenderFns } from "./layout2.vue?vue&type=template&id=e0ceabbc&scoped=true&"
import script from "./layout2.vue?vue&type=script&lang=js&"
export * from "./layout2.vue?vue&type=script&lang=js&"
import style0 from "./layout2.vue?vue&type=style&index=0&id=e0ceabbc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ceabbc",
  null
  
)

export default component.exports